var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashbinhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39998 2.91667C8.39998 1.85812 9.2581 1 10.3166 1H13.6833C14.7419 1 15.6 1.85812 15.6 2.91667V3.45833C15.6 3.51449 15.5976 3.57007 15.5928 3.625H20.0417C20.5709 3.625 21 4.05406 21 4.58333V7.91667C21 8.44594 20.5709 8.875 20.0417 8.875H19.1928C19.1976 8.92994 19.2 8.98553 19.2 9.0417V20.0834C19.2 21.1419 18.3419 22 17.2833 22H6.71666C5.65812 22 4.79999 21.1419 4.79999 20.0834V9.0417C4.79999 8.98553 4.80241 8.92994 4.80714 8.875H3.95833C3.42906 8.875 3 8.44594 3 7.91667V4.58333C3 4.05406 3.42906 3.625 3.95833 3.625H8.40713C8.4024 3.57007 8.39998 3.51449 8.39998 3.45833V2.91667ZM10.3166 2.91667L13.6833 2.91667V3.45833L10.3166 3.45833V2.91667ZM4.91667 5.54167V6.95833H19.0833V5.54167H4.91667ZM17.2833 9.0417H6.71666L6.71666 20.0834H17.2833L17.2833 9.0417Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbinhover);
export default __webpack_public_path__ + "static/media/trashbinhover.d43f95b9.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashbinhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39998 2.91667C8.39998 1.85812 9.2581 1 10.3166 1H13.6833C14.7419 1 15.6 1.85812 15.6 2.91667V3.45833C15.6 3.51449 15.5976 3.57007 15.5928 3.625H20.0417C20.5709 3.625 21 4.05406 21 4.58333V7.91667C21 8.44594 20.5709 8.875 20.0417 8.875H19.1928C19.1976 8.92994 19.2 8.98553 19.2 9.0417V20.0834C19.2 21.1419 18.3419 22 17.2833 22H6.71666C5.65812 22 4.79999 21.1419 4.79999 20.0834V9.0417C4.79999 8.98553 4.80241 8.92994 4.80714 8.875H3.95833C3.42906 8.875 3 8.44594 3 7.91667V4.58333C3 4.05406 3.42906 3.625 3.95833 3.625H8.40713C8.4024 3.57007 8.39998 3.51449 8.39998 3.45833V2.91667ZM10.3166 2.91667L13.6833 2.91667V3.45833L10.3166 3.45833V2.91667ZM4.91667 5.54167V6.95833H19.0833V5.54167H4.91667ZM17.2833 9.0417H6.71666L6.71666 20.0834H17.2833L17.2833 9.0417Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbinhover);
export default __webpack_public_path__ + "static/media/trashbinhover.d43f95b9.svg";
export { ForwardRef as ReactComponent };